webpackJsonp([35783957827783],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      "footer",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "container footer-container" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            { style: { marginBottom: 0 } },
	            "\xA9 2019 Nathan Gaw"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Trading as Spyke Digital Ltd. // 07469745"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Find me on ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.twine.fm/nathangaw" },
	              "Twine"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "Freelance website designer/developer based in Hampshire, UK."
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _avatar = __webpack_require__(31);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      menuState: 'nav-icon1 closed'
	    }, _this.changeMenu = function () {
	      if (_this.state.menuState == 'nav-icon1 closed') {
	        _this.setState({ menuState: 'nav-icon1 open' });
	      } else {
	        _this.setState({ menuState: 'nav-icon1 closed' });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'sub-hero' },
	      _react2.default.createElement(
	        'header',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-child' },
	          _react2.default.createElement('img', { className: 'avatar header-child-child', src: _avatar2.default }),
	          _react2.default.createElement(
	            'h4',
	            { className: 'header-child-child' },
	            'Nathan Gaw // Spyke Digital'
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _avatar = __webpack_require__(31);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectCard = function (_React$Component) {
	  _inherits(ProjectCard, _React$Component);
	
	  function ProjectCard() {
	    _classCallCheck(this, ProjectCard);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProjectCard.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'a',
	        { style: { textDecoration: 'none' }, href: this.props.link, target: '_blank' },
	        _react2.default.createElement(
	          'div',
	          { className: 'project-card', id: this.props.id },
	          _react2.default.createElement(
	            'div',
	            { className: 'project-text' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'project-name' },
	              this.props.name
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'project-link' },
	              'View project'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ProjectCard;
	}(_react2.default.Component);
	
	exports.default = ProjectCard;
	module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _avatar = __webpack_require__(31);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _computer = __webpack_require__(610);
	
	var _computer2 = _interopRequireDefault(_computer);
	
	var _trinity2x = __webpack_require__(611);
	
	var _trinity2x2 = _interopRequireDefault(_trinity2x);
	
	var _ProjectCard = __webpack_require__(254);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* import Link from 'gatsby-link' */
	
	
	var ProjectsGrid = function (_React$Component) {
	  _inherits(ProjectsGrid, _React$Component);
	
	  function ProjectsGrid() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProjectsGrid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      projects: [{ id: 'Qi',
	        name: 'Qi Statistics',
	        url: 'https://www.qistatistics.co.uk'
	      }, { id: 'Sophie',
	        name: 'Sophie Doula',
	        url: 'https://www.sophiedoula.com'
	      }, { id: 'Envirohive',
	        name: 'Envirohive',
	        url: 'https://www.envirohive.co.uk/'
	      }, { id: 'Trinity',
	        name: 'Trinity',
	        url: 'http://www.trinityrock.com'
	      }, { id: 'Garnet',
	        name: 'Garnet',
	        url: 'https://www.garneteducation.com'
	      }, { id: 'eLM',
	        name: 'eLearning Marketplace',
	        url: 'https://www.elearningmarketplace.co.uk'
	      }]
	
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ProjectsGrid.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'project-grid' },
	      this.state.projects.map(function (project) {
	        return _react2.default.createElement(_ProjectCard2.default, { key: project.name, name: project.name, id: project.id, link: project.url });
	      })
	    );
	  };
	
	  return ProjectsGrid;
	}(_react2.default.Component);
	
	exports.default = ProjectsGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/avatar.5c027f44.jpg";

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/computer.c77ba189.jpg";

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trinity-2x.265682b2.jpg";

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(48);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ProjectsGrid = __webpack_require__(255);
	
	var _ProjectsGrid2 = _interopRequireDefault(_ProjectsGrid);
	
	var _Footer = __webpack_require__(91);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    var _React$createElement, _React$createElement2;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'computer' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero' },
	                _react2.default.createElement(
	                    'form',
	                    { style: { display: 'none' }, name: 'secret', method: 'post' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'form-children' },
	                        'Name',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('input', { name: 'name', type: 'text' })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'form-children' },
	                        'Email',
	                        _react2.default.createElement('br', null),
	                        ' ',
	                        _react2.default.createElement('input', { name: 'email', type: 'email' })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'form-children' },
	                        'Message',
	                        _react2.default.createElement('br', null),
	                        ' ',
	                        _react2.default.createElement('textarea', { name: 'message' })
	                    ),
	                    _react2.default.createElement('input', (_React$createElement = { value: 'Send', className: 'form-children', type: 'submit' }, _React$createElement['className'] = 'blue-button', _React$createElement.style = { height: '45.2px' }, _React$createElement))
	                ),
	                _react2.default.createElement(_Header2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container hero-container' },
	                    _react2.default.createElement(
	                        'h1',
	                        { style: { marginBottom: '10px', marginTop: '10px' } },
	                        'I build websites that build businesses.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { style: { color: 'white' } },
	                        'Whether you are looking for a simple one-page website, or a large ecommerce site, I\'ll create a fast, beautiful website that will help build your business.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#contact' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'blue-button', style: { marginTop: '10px' } },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Get in touch'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'container intro-copy' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'intro-copy-text' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'How can I help you?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Having spent many years in digital marketing and search engine optimisation before I became a developer I understand how to build a commercially successful website.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'I\'ll build you a site that works flawlessly on all devices, loads quickly and engages and converts your customers.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#contact' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'blue-button', style: { marginTop: '10px' } },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Get in touch'
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'container projects' },
	            _react2.default.createElement(
	                'h2',
	                { style: { marginTop: '40px' } },
	                'Work.'
	            ),
	            _react2.default.createElement(_ProjectsGrid2.default, null)
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { marginTop: '40px', background: 'linear-gradient(to right, #000046, #168F98, #1CB5E0)' } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container', id: 'contact' },
	                _react2.default.createElement(
	                    'h2',
	                    { style: { paddingTop: '40px', color: 'white', textAlign: 'center' } },
	                    'Let\'s talk about your project.'
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { name: 'contact', method: 'post', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field' },
	                    _react2.default.createElement(
	                        'label',
	                        { style: { display: 'none' }, className: 'form-children' },
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('input', { name: 'bot-field', type: 'text' })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'form-children' },
	                        'Name',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('input', { name: 'name', type: 'text' })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'form-children' },
	                        'Email',
	                        _react2.default.createElement('br', null),
	                        ' ',
	                        _react2.default.createElement('input', { name: 'email', type: 'email' })
	                    ),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'form-children' },
	                        'Message',
	                        _react2.default.createElement('br', null),
	                        ' ',
	                        _react2.default.createElement('textarea', { name: 'message' })
	                    ),
	                    _react2.default.createElement('div', { className: 'form-children', 'data-netlify-recaptcha': true }),
	                    _react2.default.createElement('input', (_React$createElement2 = { value: 'Send', className: 'form-children', type: 'submit' }, _React$createElement2['className'] = 'blue-button', _React$createElement2.style = { height: '45.2px' }, _React$createElement2))
	                )
	            )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	    );
	};
	/* import Link from 'gatsby-link' */
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d7d1109e4ce8b7ac7c7b.js